import {
  FilterCategoryModel,
  FilterItemModel,
} from "@/models/filterItem.model";
import { KioskModel } from "@/models/kiosk.model";
import Wifi from "@/assets/wifi.svg";
import Share from "@/assets/coin.svg";
import { AmenityModel } from "proximiio-js-library/lib/models/amenity";
import Feature from "proximiio-js-library/lib/models/feature";
import Entertainment from "@/assets/entertainment.svg";
import iFly from "@/assets/ifly.svg";
import LittleExplorers from "@/assets/little-explorers.svg";
import MagicPlanet from "@/assets/magic-planet.svg";
import Snow from "@/assets/snow.svg";
import VoxCinema from "@/assets/vox-cinema.svg";
import {
  FaBabyCarriage,
  FaHotel,
  FaIceCream,
  FaLandmark,
  FaToilet,
  FaUtensils,
} from "react-icons/fa6";
import { TbBuildingCarousel } from "react-icons/tb";
import {
  FaCoffee,
  FaFirstAid,
  FaInfoCircle,
  FaParking,
  FaShoppingBag,
} from "react-icons/fa";

export const getListAsClosest = () => {
  const closestList = [];
  for (const category of filterCategories) {
    closestList.push(category.items.filter((item) => item.listAsClosest));
  }
  return closestList.flat(2);
};

export const getHiddenItems = () => {
  const list = [];
  for (const category of filterCategories) {
    for (const item of category.items.filter((item) => item.hideMapIcon)) {
      list.push(item.id);
    }
  }
  return list.flat(2);
};

export const getExcludedItems = () => {
  const list = [];
  for (const category of filterCategories) {
    for (const item of category.items.filter(
      (item) => item.excludeFromSearch,
    )) {
      list.push(item.id);
    }
  }
  return list.flat(2);
};

export const getHiddenUntilSelectedItems = () => {
  const list = [];
  for (const category of filterCategories) {
    for (const item of category.items.filter(
      (item) => item.hideIconUntilSelected,
    )) {
      list.push(item.id);
    }
  }
  return list.flat();
};

export const filterCategories: FilterCategoryModel[] = [
  {
    title: "attractions",
    id: "attractions",
    color: "185.6,100%,41.8%",
    items: [
      {
        title: "rides",
        icon: TbBuildingCarousel,
        id: [
          "d694c68b-4b9f-4294-9c7b-71ab7faf8789:15aee654-9d88-41d3-a90e-886a8ea7712f",
          "d694c68b-4b9f-4294-9c7b-71ab7faf8789:14cb7e87-8f51-4480-93ac-021e69769578",
          "d694c68b-4b9f-4294-9c7b-71ab7faf8789:d42cce7c-a070-4e83-98c1-2dcc23fba076",
          "d694c68b-4b9f-4294-9c7b-71ab7faf8789:a93ea496-08c2-4a3f-903d-f1679e69df77",
          "d694c68b-4b9f-4294-9c7b-71ab7faf8789:c2dabc9c-e3be-494f-895a-d0a228dd8210",
          "d694c68b-4b9f-4294-9c7b-71ab7faf8789:f6848f21-6310-4086-8149-116f45db9cdd",
        ],
        type: "list",
        hideIconUntilSelected: false,
        color: "152,70%,55%",
      },
      {
        title: "attractions",
        icon: FaLandmark,
        id: [
          "d694c68b-4b9f-4294-9c7b-71ab7faf8789:93db198b-c3a2-4dab-a82c-923ec96ae453",
        ],
        type: "list",
        hideIconUntilSelected: false,
        color: "202,81%,81%",
      },
      {
        title: "restaurants",
        icon: FaUtensils,
        id: [
          "d694c68b-4b9f-4294-9c7b-71ab7faf8789:b38258e1-8105-46fa-b8d4-76d61a15a4d4",
          "d694c68b-4b9f-4294-9c7b-71ab7faf8789:3c4db6e9-e937-4e8c-89f5-4726ccff275e",
          "d694c68b-4b9f-4294-9c7b-71ab7faf8789:703bd1c8-7d75-411d-b244-e103ab7e1bd5",
        ],
        type: "list",
        hideIconUntilSelected: false,
        color: "47,99%,53%",
      },
      {
        title: "cafes",
        icon: FaCoffee,
        id: [
          "d694c68b-4b9f-4294-9c7b-71ab7faf8789:2123544b-0639-4c5f-a8d7-e96e22833f52",
          "d694c68b-4b9f-4294-9c7b-71ab7faf8789:703bd1c8-7d75-411d-b244-e103ab7e1bd5",
          "d694c68b-4b9f-4294-9c7b-71ab7faf8789:16edd452-1ef1-48a9-9b0e-7b9dff6e6f45",
          "d694c68b-4b9f-4294-9c7b-71ab7faf8789:e5ce2a2a-1a5a-44bf-b7d2-b9619b6396fc",
        ],
        type: "list",
        hideIconUntilSelected: false,
        color: "18,86%,49%",
      },
      {
        title: "snacks",
        icon: FaIceCream,
        id: [
          "d694c68b-4b9f-4294-9c7b-71ab7faf8789:3dd23d83-78a1-4132-b313-5b4d771c884a",
          "d694c68b-4b9f-4294-9c7b-71ab7faf8789:d250c60f-1931-4882-82cb-1dc33be70fbc",
        ],
        type: "list",
        hideIconUntilSelected: false,
        color: "43,64%,52%",
      },
      {
        title: "shops",
        icon: FaShoppingBag,
        id: [
          "d694c68b-4b9f-4294-9c7b-71ab7faf8789:288ba368-c07a-485f-99b1-f0f61a81318b",
        ],
        type: "list",
        hideIconUntilSelected: false,
        color: "40,91%,57%",
      },
      {
        title: "accommodation",
        icon: FaHotel,
        id: [
          "d694c68b-4b9f-4294-9c7b-71ab7faf8789:8f4fd6ba-38a6-4eb2-b2cd-2a270af73cd8",
          "d694c68b-4b9f-4294-9c7b-71ab7faf8789:8d392a48-2317-4a6f-9f0b-62d2ba119e99",
          "d694c68b-4b9f-4294-9c7b-71ab7faf8789:d5e81483-4313-440c-b0a7-c1998ed0830e",
          "d694c68b-4b9f-4294-9c7b-71ab7faf8789:5b4b9e6c-da42-4a8f-a3be-3718d4f18326",
          "d694c68b-4b9f-4294-9c7b-71ab7faf8789:1cd21a9c-694b-4555-b8e8-6d75e429db56",
        ],
        type: "list",
        hideIconUntilSelected: false,
        color: "221,43%,32%",
      },
    ],
  },
  {
    title: "amenities",
    id: "amenities",
    color: "40.6,99%,61.4%",
    items: [
      {
        title: "toilet",
        icon: FaToilet,
        id: [
          "d694c68b-4b9f-4294-9c7b-71ab7faf8789:3c8f00fc-f507-4709-ad66-dd315425df36",
          "d694c68b-4b9f-4294-9c7b-71ab7faf8789:6cd425b7-cf27-4e05-a2cb-e3c307da50d7",
        ],
        type: "list",
        hideIconUntilSelected: false,
        color: "36,90%,92%",
      },
      {
        title: "nursery-rooms",
        icon: FaBabyCarriage,
        id: [
          "d694c68b-4b9f-4294-9c7b-71ab7faf8789:f9cdcf5f-f649-41de-9a7e-4086e711baf0",
        ],
        type: "list",
        hideIconUntilSelected: false,
        color: "36,90%,92%",
      },
      {
        title: "first-aid",
        icon: FaFirstAid,
        id: [
          "d694c68b-4b9f-4294-9c7b-71ab7faf8789:7f77df9c-b6ff-40f4-838e-b1faec506fdc",
          "d694c68b-4b9f-4294-9c7b-71ab7faf8789:54185239-90ce-418d-93a8-2fca958c1155",
        ],
        type: "list",
        hideIconUntilSelected: false,
        color: "19,85%,95%",
      },
      {
        title: "information",
        icon: FaInfoCircle,
        id: [
          "d694c68b-4b9f-4294-9c7b-71ab7faf8789:0a31071b-0f43-4c77-bb6f-bbab10077a94",
          "d694c68b-4b9f-4294-9c7b-71ab7faf8789:a4c78fc8-c37e-41f0-8698-414e49b7a150",
        ],
        type: "list",
        hideIconUntilSelected: false,
        color: "152,74%,95%",
      },
      {
        title: "parking",
        icon: FaParking,
        id: [
          "d694c68b-4b9f-4294-9c7b-71ab7faf8789:7e925ede-ee4d-48f3-a620-f8c8164b136f",
          "d694c68b-4b9f-4294-9c7b-71ab7faf8789:1d790b28-e25b-49c7-8ab2-a605f460cbd2",
          "d694c68b-4b9f-4294-9c7b-71ab7faf8789:2bbb8850-b127-4f32-8fa6-36c5137df947",
        ],
        type: "list",
        hideIconUntilSelected: false,
        color: "201,79%,94%",
      },
      {
        title: "vacant",
        id: [],
        type: "list",
        listed: false,
        hideMapIcon: true,
        excludeFromSearch: true,
        hideIconUntilSelected: true,
        listAsClosest: false,
      },
      {
        title: "others",
        id: [],
        type: "list",
        listed: false,
        hideMapIcon: true,
        excludeFromSearch: false,
        hideIconUntilSelected: true,
        listAsClosest: false,
      },
      {
        title: "notlistedbuttobehide",
        id: [],
        type: "list",
        listed: false,
      },
      {
        title: "wifi",
        iconImage: Wifi,
        type: "info",
        listed: false,
        content: {
          en: `
						<h3 class="text-xl font-bold my-4">#Free_ Mall_WiFi</h3>
						<p class="font-bold mb-4">We Understand that staying connected is important in today’s world. That’s why we’re excited to offer #Free_ Mall_WiFi to all our shoppers.</p>
						<ul class="mb-4">
							<li>1. Please choose #Free_Mall_WiFi from the list of Wi-Fi networks.</li>
							<li>2. Your device should automatically be taken to our login page.</li>
							<li>3. Enter your details and follow the instructions to gain high-speed internet service.</li>
						</ul>
					`,
          ar: `
						<h3 class="text-xl font-bold my-4">#Free_ Mall_WiFi</h3>
						<p class="font-bold mb-4">نحن نتفهم أن البقاء على اتصال أمر مهم في عالم اليوم.لهذا السبب نحن متحمسون لتقديم خدمة فري وايفاي لجميع المتسوقين لدينا</p>
						<ul>
							<li>من قائمة الشبكات #Free_Mall_WiFi الرجاء اختيار</li>
							<li>يجب أن يتم نقل جهازك تلقائيا إلى صفحة تسجيل الدخول الخاصة بنا</li>
							<li>أدخل بياناتك واتبع التعليمات للحصول على خدمة إنترنت عالي السرعة</li>
						</ul>
					`,
        },
      },
      {
        title: "share",
        iconImage: Share,
        type: "info",
        listed: false,
        content: {
          en: `
						<a href="https://www.sharerewards.com/" target="_blank" class="text-blue-700 hover:text-primary mt-4 block text-lg font-semibold">Join SHARE</a>
						<h3 class="text-2xl font-bold mb-6">Get More At City Centre Mirdif</h3>
						<p class="mb-6">As a member of the SHARE rewards programme, you get cash back in points at all stores and restaurants in City Centre Mirdif and beyond. Join the SHARE programme now – it’s free and will only take you a few minutes.</p>
						<a href="https://www.sharerewards.com/" target="_blank" class="text-blue-700 hover:text-primary text-lg font-semibold">Join SHARE Rewards</a>
					`,
          ar: `
					<a href="https://www.sharerewards.com/" target="_blank" class="text-blue-700 hover:text-primary mt-4 block text-lg font-semibold">سجلوا في تطبيق شير</a>
					<h3 class="text-2xl font-bold mb-6">احصلوا على المزيد في سيتي سنتر مردف</h3>
					<p class="mb-6">تخولكم عضويتكم في برنامج المكافآت شير استرداد بعض النقود في صورة نقاط لدى جميع المتاجر والمطاعم في سيتي سنتر مردف وأماكن أخرى خارج المول. انضموا إلى برنامج المكافآت شير الآن - فهو مجاني ولا يلزم لانضمامكم إليه سوى دقائق معدودة.</p>
					<a href="https://www.sharerewards.com/" target="_blank" class="text-blue-700 hover:text-primary text-lg font-semibold">سجلوا في تطبيق شير</a>
					`,
        },
      },
    ],
  },
];

filterCategories.push({
  title: "hidden",
  id: "hidden",
  listed: false,
  items: [
    {
      title: "hidden",
      id: getHiddenUntilSelectedItems() as string[],
      type: "list",
      listed: false,
    },
  ],
});

export const kiosks: KioskModel[] = [
  /*{
    name: "kiosk",
    latitude: 25.21620020891565,
    longitude: 55.40792571152656,
    level: 0,
    pitch: 40,
    bearing: 10,
    zoom: 18,
    poiId:
      "75698d35-0918-4a2b-a8ab-77b93a618e61:c2f3d327-d2ee-4d6f-a14f-2a85dfb1ab8d",
  },*/
];

export const excludedAmenities: string[] = getExcludedItems() as string[];

// Function to build additional filters based on amenities and features
export const buildAdditionalFilters = ({
  amenities,
  features,
  language,
}: {
  amenities: AmenityModel[] | null;
  features: Feature[] | null;
  language: string;
}): FilterItemModel[] | void => {
  // Early exit if amenities or features are missing
  if (!amenities) {
    console.error("amenities is null");
    return;
  }

  if (!features) {
    console.error("features is null");
    return;
  }

  // Define amenity titles and their mapping to ids/features
  const amenityMapping: {
    [key: string]: {
      amenity?: AmenityModel;
      features: Feature[];
      icon: string;
    };
  } = {
    "Snow/Ski": { amenity: undefined, features: [], icon: Snow },
    "Vox Cinema": { amenity: undefined, features: [], icon: VoxCinema },
    "Magic Planet": { amenity: undefined, features: [], icon: MagicPlanet },
    iFLY: { amenity: undefined, features: [], icon: iFly },
    "Little Explorers": {
      amenity: undefined,
      features: [],
      icon: LittleExplorers,
    },
    Entertainment: { amenity: undefined, features: [], icon: Entertainment },
  };

  // Map amenities to their respective amenity titles
  for (const amenity of amenities) {
    if (amenityMapping[amenity.title]) {
      amenityMapping[amenity.title].amenity = amenity;
    }
  }

  // Map features to their respective amenities
  for (const feature of features) {
    for (const key in amenityMapping) {
      const { amenity } = amenityMapping[key];
      if (feature.properties?.amenity === amenity?.id) {
        amenityMapping[key].features.push(feature);
      }
    }
  }

  // Utility function to retrieve a translated title
  const getTranslatedTitle = (feature: Feature): string => {
    const { title_i18n, title } = feature.properties || {};
    return title_i18n?.[language] || title_i18n?.en || title;
  };

  const items: FilterItemModel[] = [];

  // Create filter items for each amenity based on available features
  for (const key in amenityMapping) {
    const { amenity, features, icon } = amenityMapping[key];

    if (amenity && features.length > 0) {
      let itemTitle: string | undefined;

      // If there is only one feature, use the feature title
      if (features.length === 1) {
        itemTitle = getTranslatedTitle(features[0]);
      }

      // Set up the item object for the filter list
      const baseItem: FilterItemModel = {
        title: key.toLowerCase().replace(/\s/g, "-"), // Convert title to kebab-case
        translatedTitle: itemTitle,
        iconImage: icon,
        id: [amenity.id],
        hideMapIcon: true,
        type: "list",
      };

      // Push items to the list based on the type (list or single)
      if (key === "Entertainment") {
        // For "Entertainment", push individual features
        features.forEach((feature) => {
          items.push({
            ...baseItem,
            type: "single",
            title: getTranslatedTitle(feature)
              .toLowerCase()
              .replace(/\s/g, "-"), // Convert title to kebab-case
            translatedTitle: getTranslatedTitle(feature),
            featureId: feature.id,
          });
        });
      } else {
        // For other amenities, push as a list
        items.push(baseItem);
      }
    }
  }

  const entertainmentIndex = filterCategories.findIndex(
    (category) => category.id === "entertainment",
  );
  filterCategories[entertainmentIndex].items = items;
};
